import Vue from 'vue'
import Router from 'vue-router'
import Demo from '@/components/Demo'
import Auth from '@/components/Auth'

import store from '../stores/app.store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Demo',
      component: Demo,
      beforeEnter(to, from, next) {
        if (store.state.loggedIn) next();
        else next('/auth');
      }
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
      beforeEnter(to, from , next) {
        if (store.state.loggedIn) next('/');
        else next();
      }
    },
    {
      path: '/:slug',
      name: 'Help Page',
      component: Demo,
      beforeEnter(to, from, next) {
        if (store.state.loggedIn) next();
        else next('/auth');
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js